import { FC, PropsWithChildren } from "react";
import { LoadingAnimation } from "@/components/LoadingAnimation";
import { useFetchErpFeatures } from "../hooks/useErpFeaturesProvider";
import { ErpFeatureKeys } from "../models/erpFeature";

interface IErpFeaturesProviderProps extends PropsWithChildren {
  debugFeatures?: ErpFeatureKeys[];
}

const ErpFeaturesProvider: FC<IErpFeaturesProviderProps> = ({ 
  children, debugFeatures
} ) => {

  const { loading } = useFetchErpFeatures(debugFeatures);

  return loading ? <LoadingAnimation/> : children
}

export default ErpFeaturesProvider;
